
export const taskSummaryFilters = {
  namespaced: true,
  state: () => ({
    coachingDefinitionFilters: [],
    taskTitleFilters: [],
    startDateFilter: null,
    endDateFilter: null,
    filtersReady: false,
  }),
  mutations: {
    SET_COACHING_DEFINITION_FILTERS(state, filters) {
      state.coachingDefinitionFilters = filters;
    },
    SET_TASK_TITLE_FILTERS(state, filters) {
      state.taskTitleFilters = filters;
    },
    SET_START_DATE_FILTER(state, date) {
      state.startDateFilter = date;
    },
    SET_END_DATE_FILTER(state, date) {
      state.endDateFilter = date;
    },
    SET_FILTERS_READY(state, status) {
      state.filtersReady = status;
    },
  },
  getters: {
    coachingDefinitionFilters: state => state.coachingDefinitionFilters,
    taskTitleFilters: state => state.taskTitleFilters,
    startDateFilter: state => state.startDateFilter,
    endDateFilter: state => state.endDateFilter,
    filtersReady: state => state.filtersReady,
  },
  actions: {
    setCoachingDefinitionFilters({ commit }, filters) {
      commit("SET_COACHING_DEFINITION_FILTERS", filters);
    },
    setTaskTitleFilters({ commit }, filters) {
      commit("SET_TASK_TITLE_FILTERS", filters);
    },
    setStartDateFilter({ commit }, date) {
      commit("SET_START_DATE_FILTER", date);
    },
    setEndDateFilter({ commit }, date) {
      commit("SET_END_DATE_FILTER", date);
    },
    setFiltersReady({ commit }, status) {
      commit("SET_FILTERS_READY", status)
    }
  },
};
